import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import { Star, Timer } from 'iconsax-react'

import { View } from '../..'
import Card from '@SonarCX/components/atoms/MediaAvatar/Card'

import useStyles from '../../styles'

interface UserColumnProps {
  user: APIUser
  view: View
  setView: (view: View) => void
}

const UserColumn: React.FC<UserColumnProps> = ({ user, view, setView }) => {
  const theme = useTheme()
  const classes = useStyles()

  const handleOnRowClick = React.useCallback(
    view => {
      setView(view)
    },
    [setView]
  )

  return (
    <div>
      <h4 className={clsx(classes.header, classes.alignCenter)}>Your space</h4>
      <Card
        // @ts-ignore
        hideHeader
        user={user}
        rootStyles={clsx(classes.contactBackground, classes.myProfileCard)}
      />
      <div className={classes.cardBottom}>
        <div
          className={clsx(
            classes.cardBottomRow,
            view === View.Recent && classes.activeCardBottomRow
          )}
          onClick={() => handleOnRowClick(View.Recent)}
        >
          <Timer
            variant='Bulk'
            size={theme.size.base}
            color={theme.palette.primary.main}
          />
          Recent
        </div>
        <div
          className={clsx(
            classes.cardBottomRow,
            view === View.Favorite && classes.activeCardBottomRow
          )}
          onClick={() => handleOnRowClick(View.Favorite)}
        >
          <Star
            variant='Bulk'
            size={theme.size.base}
            color={theme.palette.primary.main}
          />
          Favorites
        </div>
      </div>
    </div>
  )
}

export default UserColumn
